<template>
    <PatientRowCells :patient="patient" class="table-tr">
        <span :id="`patient-${patient.id}`" class="patient-anchor"></span>

        <div class="table-td cell-length">
        <div class="patient-wrapper">
            <user-avatar :user-info="patient"></user-avatar>

            <div class="patient-info">
                <span class="user-name">
                    <strong v-if="patient.patient_id">{{ patient.patient.user | fullname }}</strong>
                    <strong v-else-if="patient.name || patient.surname">{{ patient | fullname }}</strong>
                    <strong v-else-if="patient.invitation.in_app">{{ __("Invitation patient") }}</strong>
                    <strong v-else>{{ __("Patient leaflet") }}</strong>
                </span>
                <span class="patient-mail">{{ patient.patient_id ? patient.patient.user.email : patient.email }}</span>
                <span class="patient-phone">{{ patient.phone }}</span>
            </div>
        </div>
    </div>
    </PatientRowCells>
</template>

<script>
import PatientRowCells from './PatientRowCells'
import PatientUserImage from '@components/PatientsMatrix/Cells/PatientUserImage'

export default {
    components: {
        PatientRowCells,
        PatientUserImage
    },
    props: {
        patient: {
            type: Object,
            required: true
        }
    }
}
</script>
